export default "__VITE_ASSET__BJjsZuZD__"